import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { themeColorSet, ThemedPressable, ThemedText } from "@app/theme"
import { FlatList } from "react-native";
import { ThemedView } from "@app/theme"
import { ScrollView } from "react-native";
import ROUTE from "@app/navigationApp/routes";
import { CaretRight, X } from '../../sharedComponents/Icons/index';

const renderItem = ({item, index,navigation}: {item: any; index: number; navigation: any}) => {
    return (
        <ThemedPressable 
        eventName="FAQ_SELECTED"
        eventProperty={{ question : item?.title}}
        onPress={() => navigation.navigate(ROUTE.FAQ_DETAILS_SCREEN_REVAMP, { data : item?.cardDetails,title : item?.title })}
            mt="sm"
            px="md"
            py="md"
            borderWidth={1}
            borderRadius="sm"
            backgroundColor="bg-surface-primary"
            flexDirection="row"
            justifyContent="space-between"
            borderColor="border-primary"
            alignItems="center">
            <ThemedView flexShrink={1}>
                <ThemedText 
                    variant="b3r"
                    color="text-primary">
                    {item?.title}
                </ThemedText>
            </ThemedView>
            {<CaretRight size={16} />}
        </ThemedPressable>
    )
}

const FaqScreenRevamp = ({navigation,route}: {navigation: any; route: any}) => {

    const {title,item} = route?.params;

    return (
        <>
        <PageHeaders label="FAQs" pageName="FAQ_SCREEN_REVAMP" navigation={navigation}/>
        <ScrollView style={{backgroundColor:themeColorSet["bg-surface-page"] , flex:1}}>    
            <ThemedView mt="2xl" px="lg" pb="lg">
                <ThemedText variant="h3s" color="text-primary">
                    {title}
                </ThemedText>
                <ThemedView mt="sm">
                    <FlatList
                        data={item}
                        renderItem={({item, index}) => renderItem({item, index, navigation})}
                        keyExtractor={(item) => item.id}
                    />
                </ThemedView>
            </ThemedView>
        </ScrollView>
        </>
    )
}       

export default FaqScreenRevamp; 